module.exports = __webpack_public_path__ + "img/ShadowFiend.fe3da56b.png";